module.exports = __webpack_public_path__ + "img/能耗2.1d6faad9.jpg";